import { render, staticRenderFns } from "./HoverButton.vue?vue&type=template&id=0774db9b&scoped=true&"
import script from "./HoverButton.vue?vue&type=script&lang=js&"
export * from "./HoverButton.vue?vue&type=script&lang=js&"
import style0 from "./HoverButton.vue?vue&type=style&index=0&id=0774db9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0774db9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VHover,VIcon})
